// src/services/http.js
import { env } from "../config/env";
import {
  getAuthToken,
  clearAllAuthState,
} from "../pages/AdminAuth/components/authStore";

async function readJson(res) {
  const text = await res.text();
  try {
    return text ? JSON.parse(text) : {};
  } catch {
    return { message: text || "Invalid JSON response" };
  }
}

function withQuery(url, params) {
  if (!params || typeof params !== "object") return url;

  const usp = new URLSearchParams();

  for (const [k, v] of Object.entries(params)) {
    if (v === undefined || v === null || v === "") continue;
    usp.append(k, String(v));
  }

  const qs = usp.toString();
  return qs ? `${url}${url.includes("?") ? "&" : "?"}${qs}` : url;
}

async function request(
  baseURL,
  path,
  { method = "GET", body, headers = {}, params } = {}
) {
  const url0 = `${baseURL}${path.startsWith("/") ? "" : "/"}${path}`;
  const url = withQuery(url0, params);
  const token = getAuthToken();

  const finalHeaders = {
    ...(token ? { Authorization: `Bearer ${token}` } : {}),
    ...headers,
  };

  let requestBody;

  // FormData support for file upload
  if (body instanceof FormData) {
    requestBody = body;
    // Content-Type manually mat lagana
    // browser khud multipart/form-data boundary set karega
  } else if (body !== undefined) {
    finalHeaders["Content-Type"] = "application/json";
    requestBody = JSON.stringify(body);
  }

  const res = await fetch(url, {
    method,
    headers: finalHeaders,
    body: requestBody,
  });

  const data = await readJson(res);

  if (!res.ok) {
    if (res.status === 401) {
      clearAllAuthState();
    }

    const msg =
      data?.message || data?.error || data?.errors?.[0]?.message || `Request failed (${res.status})`;

    const err = new Error(msg);
    err.status = res.status;
    err.data = data;
    throw err;
  }

  return data;
}

export async function http(path, options = {}) {
  return request(env.AUTH_BASE_URL, path, options);
}

export function createClient(baseURL) {
  return {
    get: (path, opts = {}) =>
      request(baseURL, path, { ...opts, method: "GET" }),

    post: (path, body, opts = {}) =>
      request(baseURL, path, { ...opts, method: "POST", body }),

    patch: (path, body, opts = {}) =>
      request(baseURL, path, { ...opts, method: "PATCH", body }),

    put: (path, body, opts = {}) =>
      request(baseURL, path, { ...opts, method: "PUT", body }),

    del: (path, opts = {}) =>
      request(baseURL, path, { ...opts, method: "DELETE" }),
  };
}